export class UserGeneralKey {
    static isTokenValid() {
        const token = localStorage.getItem(UserGeneralKey.USER_TOKEN);
        if (!token)
            return false;
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const expiry = payload.exp;
            const now = Math.floor(Date.now() / 1000);
            return expiry > now;
        }
        catch (error) {
            return false;
        }
    }
    static logout() {
        this.clearAllUserData();
    }
    static saveUserDatA(user) {
        if (!user.roles || !Array.isArray(user.roles) || user.roles.length === 0) {
            console.error('❌ saveUserDatA: Aucun rôle valide trouvé dans user.roles:', user.roles);
            throw new Error('Aucun rôle utilisateur valide trouvé');
        }
        const role = user.roles[0];
        if (!role) {
            console.error('❌ saveUserDatA: Le premier rôle est vide');
            throw new Error('Le rôle utilisateur est vide');
        }
        localStorage.setItem(UserGeneralKey.USER_ROLE, role);
        localStorage.setItem(UserGeneralKey.USER_ID, user.id);
        localStorage.setItem(UserGeneralKey.USER_EMAIL, user.email);
        localStorage.setItem(UserGeneralKey.USER_FIRST_NAME, user.first_name);
        localStorage.setItem(UserGeneralKey.USER_LAST_NAME, user.last_name);
        if (user.restaurant_id) {
            localStorage.setItem(UserGeneralKey.USER_RESTAURANT_ID, user.restaurant_id);
        }
        else if (user.restaurant && user.restaurant.id) {
            localStorage.setItem(UserGeneralKey.USER_RESTAURANT_ID, user.restaurant.id);
        }
        // Récupération de la franchise : peut être dans user.franchise (string) ou user.franchiseID (objet)
        const u = user;
        const franchiseId = u.franchise ||
            (u.franchiseID && typeof u.franchiseID === 'object' ? u.franchiseID.id : null) ||
            (u.restaurant && u.restaurant.franchiseID && typeof u.restaurant.franchiseID === 'object' ? u.restaurant.franchiseID.id : null);
        if (franchiseId && franchiseId !== 'undefined' && franchiseId !== 'null') {
            localStorage.setItem(UserGeneralKey.USER_FRANCHISE_ID, franchiseId);
        }
        if (typeof user.profil_picture === "string") {
            localStorage.setItem(UserGeneralKey.USER_PROFIL_IMG, user.profil_picture);
        }
        const savedRole = localStorage.getItem(UserGeneralKey.USER_ROLE);
        if (savedRole !== role) {
            console.error('❌ saveUserDatA: Le rôle n\'a pas été sauvegardé correctement. Attendu:', role, 'Reçu:', savedRole);
        }
    }
    static clearAllUserData() {
        localStorage.removeItem(UserGeneralKey.USER_TOKEN);
        localStorage.removeItem(UserGeneralKey.USERNAME);
        localStorage.removeItem(UserGeneralKey.USER_ID);
        localStorage.removeItem(UserGeneralKey.USER_EMAIL);
        localStorage.removeItem(UserGeneralKey.USER_FIRST_NAME);
        localStorage.removeItem(UserGeneralKey.USER_LAST_NAME);
        localStorage.removeItem(UserGeneralKey.USER_ROLE);
        localStorage.removeItem(UserGeneralKey.USER_FRANCHISE_ID);
        localStorage.removeItem(UserGeneralKey.USER_RESTAURANT_ID);
        localStorage.removeItem(UserGeneralKey.USER_PROFIL_IMG);
    }
    static getRole(role) {
        switch (role) {
            case 'ROLE_ADMIN':
                return 'ADMINISTRATEUR';
            case 'ROLE_USER':
                return 'UTILISATEUR';
            case 'ROLE_FRANCHISE':
                return 'FRANCHISE';
            case 'ROLE_RESTAURANT':
                return 'RESTAURANT';
            case 'ROLE_SUPPORT_TECHNIQUE':
                return 'SUPPORT TECHNIQUE';
            default:
                return 'SUPPORT TECHNIQUE';
        }
    }
    static formatDateToFrenchLocale(dateString) {
        const date = new Date(dateString);
        const dateOptions = {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            timeZone: 'Europe/Zurich'
        };
        const timeOptions = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone: 'Europe/Zurich'
        };
        const formattedDate = date.toLocaleDateString('fr-FR', dateOptions);
        const formattedTime = date.toLocaleTimeString('fr-FR', timeOptions);
        return `${formattedDate} à ${formattedTime}`;
    }
    static isAdmin(role) {
        const userRole = role || localStorage.getItem(UserGeneralKey.USER_ROLE);
        if (!userRole)
            return false;
        return String(userRole).trim() === UserRole.ADMIN;
    }
    static isFranchise(role) {
        const userRole = role || localStorage.getItem(UserGeneralKey.USER_ROLE);
        if (!userRole)
            return false;
        const normalizedRole = String(userRole).trim();
        return normalizedRole === 'ROLE_FRANCHISE'
            || normalizedRole === UserRole.FRANCHISE;
    }
    static getUserRole() {
        return localStorage.getItem(UserGeneralKey.USER_ROLE);
    }
    static getDashboardRoute(role) {
        const checkRole = role || (typeof localStorage !== 'undefined' ? localStorage.getItem(UserGeneralKey.USER_ROLE) : null);
        if (this.isAdmin(checkRole)) {
            return '/home';
        }
        if (this.isFranchise(checkRole)) {
            return '/admin-dashboard';
        }
        if (checkRole === UserRole.RESTAURANT) {
            return '/ajout-commande';
        }
        return '/home';
    }
}
UserGeneralKey.USER_TOKEN = "USER_TOKEN";
UserGeneralKey.USERNAME = "USERNAME";
UserGeneralKey.USER_ID = "USER_ID";
UserGeneralKey.USER_EMAIL = "USER_EMAIL";
UserGeneralKey.USER_FIRST_NAME = "USER_FIRST_NAME";
UserGeneralKey.USER_LAST_NAME = "USER_LAST_NAME";
UserGeneralKey.USER_ROLE = "USER_ROLE";
UserGeneralKey.USER_FRANCHISE_ID = "USER_FRANCHISE_ID";
UserGeneralKey.USER_FRANCHISE_NAME = "USER_FRANCHISE_NAME";
UserGeneralKey.USER_FRANCHISE_LOGO = "USER_FRANCHISE_LOGO";
UserGeneralKey.USER_FRANCHISE_FAVICON = "USER_FRANCHISE_FAVICON";
UserGeneralKey.USER_RESTAURANT_ID = "USER_RESTAURANT_ID";
UserGeneralKey.USER_PROFIL_IMG = "USER_PROFIL_IMG";
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ROLE_ADMIN";
    UserRole["FRANCHISE"] = "ROLE_FRANCHISE";
    UserRole["RESTAURANT"] = "ROLE_RESTAURANT";
    UserRole["UTILISATEUR"] = "ROLE_USER";
    UserRole["SUPPORT"] = "ROLE_SUPPORT_TECHNIQUE";
})(UserRole || (UserRole = {}));
